export const DOCTOR_PROFILE_PDF_ERROR = "Please complete the doctor's profile before generating a treatment plan.";
export const DOCTOR_PRC_PDF_ERROR = "Please complete the attending doctor's PRC number before generating a treatment plan.";

export function doctorDisplayNameComplete(name) {
  const normalized = String(name || "").trim().toLowerCase();
  return Boolean(normalized) && normalized !== "owner" && normalized !== "doctor";
}

export function treatmentPlanDoctorGate(plan) {
  const serverFlag = plan?.doctor_display_name_complete;
  const nameOk = typeof serverFlag === "boolean"
    ? serverFlag
    : doctorDisplayNameComplete(plan?.doctor_name);

  if (!nameOk) {
    return {
      ok: false,
      message: DOCTOR_PROFILE_PDF_ERROR,
      href: plan?.doctor_id ? `/settings/team?doctor=${encodeURIComponent(plan.doctor_id)}` : "/settings/team",
    };
  }

  if (!String(plan?.doctor_prc_license || "").trim()) {
    return {
      ok: false,
      message: DOCTOR_PRC_PDF_ERROR,
      href: plan?.doctor_id ? `/settings/team?doctor=${encodeURIComponent(plan.doctor_id)}` : "/settings/team",
    };
  }

  return { ok: true, message: null, href: null };
}
